import "./appLoader.css";

interface IAppLoader {
  loadingText?: string;
}
export default function AppLoader({ loadingText }: IAppLoader) {
  return (
    <>
      <div className="loader-container flex flex-col dark:bg-secondary-bg">
        <div></div>
        <p className="text-white text-center mt-6 px-6 md:text-xl 2xl:text-2xl text-md ">
          {loadingText ? loadingText : "Loading..."}
        </p>
      </div>
    </>
  );
}
